<template>
  <footer class="wec-footer">
    <div class="wec-footer__inner">
      <div class="wec-footer__top">
        <div class="wec-footer__logos">
          <img
            src="../../assets/img/we-circular/Logo_Interreg_Danube.png_ff.png"
            alt="Interreg Danube Region"
            class="wec-footer__logo"
          />
        </div>
        <div class="wec-footer__legal">
          <div class="wec-footer__heading">
            LEGAL
          </div>
          <a href="#" class="wec-footer__link">
            Cookies Policy
          </a>
        </div>
      </div>
      <div class="wec-footer__divider"></div>
      <div class="wec-footer__bottom">
        ©2026 MGFU. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'WeCircularFooter'
}
</script>

<style scoped>
.wec-footer {
  width: 100%;
  background: #004444; /* javítva */
  color: #ffffff;
}

.wec-footer__inner {
  margin: auto;
  padding: 48px 40px 32px;
}

.wec-footer__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.wec-footer__logos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.wec-footer__logo {
  height: 5vw;
}

.wec-footer__legal {
  text-align: right;
}

.wec-footer__heading {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.12em;
  margin-bottom: 10px;
}

.wec-footer__link {
  color: #ffffff;
  text-decoration: none;
  opacity: 0.9;
}

.wec-footer__link:hover {
  opacity: 1;
}

.wec-footer__divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.35); /* ez jó */
  margin: 36px 0 24px;
}

.wec-footer__bottom {
  font-size: 14px;
  opacity: 0.85;
}

@media (max-width: 900px) {
  .wec-footer__top {
    flex-direction: column;
    gap: 30px;
  }
  .wec-footer__legal {
    text-align: left;
  }
}
</style>
